enum FundBtnType {
  FUND,
  LIST
}

export default FundBtnType
